import React, { useState, useRef, useEffect } from 'react';
import './web_footer.css';
import Cookies from 'js-cookie'; 
export default function Webfooter() {

    const year = new Date().getFullYear();   // Dynamic year
 
    const [address, setAddress] = useState(Cookies.get("address") || "Fetching...");

    useEffect(() => { 
      const interval = setInterval(() => {
        setAddress(Cookies.get("address") || "Fetching...");
      }, 5000); // Update every 5 seconds
  
      return () => clearInterval(interval);
    }, []);
    return(
        <div className='web_footer_body'>
       <div className="container_size">
       <div className="tearms_div">
                        <div className="container_size">
                            <div id="footer_year_text" className="links_btn">© CallQR.Com - Kang Technology {year} All rights reserved</div>
                            {/* <a className="links_btn" href="privacy-policy">Privacy Policy</a>
                            <a className="links_btn" href="terms-of-service">Terms of Service</a>
                            <a className="links_btn" href="disclaimer">Disclaimer</a>
                            <a className="links_btn" href="faq">FAQ</a> 
                            <a className="links_btn" href="troubleshoot">Trouble shoot</a> 
                            <a className="links_btn" href="sitemap">Sitemap</a> 
                            <a className="links_btn" href="sitemap">Address: {address}</a> */}
                            <div className="company_links_btn" >Updates: 1 April 2025</div>
                        </div>
                    </div>
            </div>
        </div>
    )
}